import React from 'react';

import CoproReport from '../../components/Communication/CoproReport';

function CommunicationCoproReportView() {
  return (
    <CoproReport />
  );
}

export default CommunicationCoproReportView;
